import React, { useState, Fragment, useEffect, useRef } from 'react';
import NotificationSystem from 'react-notification-system';
import { conformToMask } from 'react-text-mask';
import Loading from 'react-loading-components';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from 'components/Header';
import get from 'lodash/get';

import { getMerchantDetail } from 'actions/application';

import style from './style.scss';

const Profile = () => {
  const dispatch = useDispatch();
  const phoneNumberMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  const [pageData, setPageData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const notificationSystem = useRef(null);

  useEffect(() => {
    const merchantId = localStorage.getItem('merchantId');
    if (merchantId) {
      dispatch(getMerchantDetail({
        url: `/merchants/${merchantId}/basic`,
        success: (res) => {
          setPageData(res);
          setIsLoading(false);
        },
        fail: (err) => {
          setIsLoading(false);
          if (err.response) {
            notificationSystem
            && notificationSystem.current.addNotification({
              message: 'fetching user detail failes',
              level: 'error',
              position: 'tc',
            });
          }
        },
      }));
    }
  }, []);

  return (
    <Fragment>
      <Header />
      <NotificationSystem ref={notificationSystem} />
      <section className="container section">
        <div className="grid-container fluid portal page-profile-settings">

          <div className="grid-x">
            <div className="cell small-12 card-grid-container">

              <div className={cn('grid-x grid-margin-x page-header', style.pageHeader)}>
                <div className="cell small-12">
                  <h3>Profile Settings</h3>
                </div>
              </div>

              <div className={cn('grid-x grid-margin-x', style.profilePanel)}>
                <div className="cell small-12 large-10">

                  <div className="card card-editable">
                    <div className="card-header">
                      <h5>Business Information</h5>
                    </div>

                    <div className={cn('card-section', style.cardSection)}>
                      {isLoading ? (
                        <div className={style.loading}>
                          <Loading type="oval" width={50} height={50} fill="#f44242" />
                        </div>
                      ) : (
                        <div className={cn('grid-x grid-margin-x', style.spaced)}>
                          <div className="cell small-12 large-6 grid-x grid-margin-x" style={{ marginLeft: 0, marginRight: 0 }}>
                            <div className="cell small-12 large-4">
                              <div className={style.field}>
                                <span>First Name</span>
                                <p>{get(pageData, 'contacts.0.firstName', '-')}</p>
                              </div>
                            </div>
                            <div className="cell small-12 large-4">
                              <div className={style.field}>
                                <span>Last Name</span>
                                <p>{get(pageData, 'contacts.0.lastName', '-')}</p>
                              </div>
                            </div>
                            <div className="cell small-12 large-6">
                              <div className={style.field}>
                                <span>Email</span>
                                <p>{get(pageData, 'contacts.0.email', '-')}</p>
                              </div>
                            </div>
                            <div className="cell small-12 large-6">
                              <div className={style.field}>
                                <span>Phone</span>
                                <p>{get(pageData, 'contacts.0.phoneNumber') ? conformToMask(get(pageData, 'contacts.0.phoneNumber'), phoneNumberMask).conformedValue : '-'}</p>
                              </div>
                            </div>
                            <div className="cell small-12">
                              <div className={style.field}>
                                <span>Title</span>
                                <p>{get(pageData, 'contacts.0.title', '-')}</p>
                              </div>
                            </div>
                          </div>
                          <div className="cell small-12 large-6 grid-x grid-margin-x" style={{ marginRight: 0, marginLeft: 0 }}>
                            <div className="cell small-12">
                              <div className={style.field}>
                                <span>Street Address</span>
                                <p>{get(pageData, 'businessAddresses.0.address', '-')}</p>
                              </div>
                            </div>
                            <div className="cell small-12 large-4">
                              <div className={style.field}>
                                <span>City</span>
                                <p>{get(pageData, 'businessAddresses.0.city', '-')}</p>
                              </div>
                            </div>
                            <div className="cell small-12 large-4">
                              <div className={style.field}>
                                <span>State</span>
                                <p>{get(pageData, 'businessAddresses.0.state', '-')}</p>
                              </div>
                            </div>
                            <div className="cell small-12 large-4">
                              <div className={style.field}>
                                <span>Zip Code</span>
                                <p>{get(pageData, 'businessAddresses.0.zipCode', '-')}</p>
                              </div>
                            </div>
                            <div className={cn('cell small-12', style.hidden)}>
                              <div className={style.field}>
                                <span>Hidden Filed</span>
                                <p>-</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};


export default withRouter(Profile);



// WEBPACK FOOTER //
// ./src/containers/pages/Profile/index.js